import RestService from "model/service/dataStorage/RestService";
import IReport, {ReportState} from "../../../interface/company/workload/IReport";
import IRestServiceCollectionResponse from "../../../interface/api/IRestServiceCollectionResponse";
import IRestServiceOptions from "../../../interface/api/IRestServiceOptions";
import IRestFile from "../../../interface/api/IRestFile";
import {Moment} from "moment";
import {API_FILTER_TYPE} from "../../../constants/ApiConstant";
import {DATE_FORMAT_YYYY_MM_DD} from "../../../constants/DateConstant";
import MasterRepositoryService from "../../dataStorage/MasterRepositoryService";
import IField from "../../../interface/dataStorage/IField";
import {Key} from "react";
import IRepositoryService from "../../../interface/IRepositoryService";
import IPresenter from "../../../interface/dataStorage/IPresenter";
import _ from "underscore";
import IRestServiceChoiceListResponse from "../../../interface/api/IRestServiceChoiceListResponse";

interface IRestReportsServiceCollectionResponse extends IRestServiceCollectionResponse {
    results: Array<IReport>
}

export type ReportOnSaveAction = 'fill_default' | 'delete_all_new' | 'check_collision'

interface IRestReportsService extends IRepositoryService {
    collectionList(options?: IRestServiceOptions): Promise<IRestReportsServiceCollectionResponse>,

    collectionListByEmployeeMonth(employee: string, month: Moment, options?: IRestServiceOptions): Promise<IRestReportsServiceCollectionResponse>,

    collectionListByMonth(month: Moment, options?: IRestServiceOptions): Promise<IRestReportsServiceCollectionResponse>,

    collectionCreate(data: any): Promise<IReport>,

    resourceRetrieve(id: number | string): Promise<IReport>,

    resourceUpdate(id: number | string, data: any, options?: IRestServiceOptions, onSave?: ReportOnSaveAction): Promise<IReport>,

    resourceDelete(id: number | string): Promise<void>

    download(id: number | string): Promise<IRestFile>

    collectionUpdateState(ids: number[], state: ReportState): Promise<{ success: boolean, count: number }>
}

const ReportsService_COLLECTION = 'company/workload/reports'
const ReportsService_DOWNLOAD = 'company/workload/reports-download/'
const UPDATE_STATES = 'company/workload/reports-change-state'

const presenters = [
    {
        type: 'label',
        name: 'default',
        label: 'Výchozí',
        options: {
            label: "#employee|default - #month"
        }
    } as IPresenter,
]

class ReportsService extends MasterRepositoryService implements IRestReportsService {

    private static instance?: ReportsService

    public static getInstance(): ReportsService {
        if (!ReportsService.instance) {
            ReportsService.instance = new ReportsService()
        }
        return ReportsService.instance
    }

    getStringValue(report: IReport): string {
        return report.month?.raw || ''
    }

    getPresenter(name: string): IPresenter | null {
        return _.findWhere(presenters, {name}) || null
    }

    getDefaultPresenter(): IPresenter {
        return presenters[0]
    }

    getPresenterList() {
        return presenters.map(presenter => {
            return {value: presenter.name, label: presenter.label}
        })
    }

    getRecordClassName(): string {
        return 'App\\Company\\Entity\\WorkLoad\\Report'
    }

    getTitle(): string {
        return 'Výkaz práce'
    }


    collectionList = (options?: IRestServiceOptions) => {
        return RestService.collectionList<IReport>(ReportsService_COLLECTION, options as unknown as IRestServiceOptions)
    }

    getMasterClassName(): string {
        return "";
    }

    getBaseFields(): IField[] {
        // TODO
        return [];
    }

    collectionListByEmployeeMonth = (employee: string, month: Moment, options?: IRestServiceOptions) => {
        return RestService.collectionList(ReportsService_COLLECTION, {
            ...options, filters: {
                employee: {
                    field: 'employee',
                    type: API_FILTER_TYPE.EQUAL,
                    value: employee
                },
                startAt: {
                    field: 'month',
                    type: API_FILTER_TYPE.GREATER_OR_EQUAL,
                    value: month.clone().startOf('month').format(DATE_FORMAT_YYYY_MM_DD) + ' 00:00:00'
                },
                endAt: {
                    field: 'month',
                    type: API_FILTER_TYPE.LESSER_OR_EQUAL,
                    value: month.clone().endOf('month').format(DATE_FORMAT_YYYY_MM_DD) + ' 23:59:59'
                }
            }
        }) as Promise<IRestReportsServiceCollectionResponse>
    }

    collectionListByMonth = (month: Moment, options?: IRestServiceOptions) => {
        return RestService.collectionList(ReportsService_COLLECTION, {
            ...options, filters: {
                startAt: {
                    field: 'month',
                    type: API_FILTER_TYPE.GREATER_OR_EQUAL,
                    value: month.clone().startOf('month').format(DATE_FORMAT_YYYY_MM_DD) + ' 00:00:00'
                },
                endAt: {
                    field: 'month',
                    type: API_FILTER_TYPE.LESSER_OR_EQUAL,
                    value: month.clone().endOf('month').format(DATE_FORMAT_YYYY_MM_DD) + ' 23:59:59'
                }
            }
        }) as Promise<IRestReportsServiceCollectionResponse>
    }

    collectionCreate = (data: any) => {
        return RestService.collectionCreate(ReportsService_COLLECTION, {...data}) as Promise<IReport>
    }
    resourceRetrieve = (id: Key) => {
        return RestService.resourceRetrieve(ReportsService_COLLECTION, id) as Promise<IReport>
    }

    resourceDelete = (id: Key) => {
        return RestService.resourceDelete(ReportsService_COLLECTION, id)
    }

    resourceUpdate = (id: Key, data: any, options?: IRestServiceOptions, onSave?: ReportOnSaveAction) => {
        return RestService.resourceUpdate(ReportsService_COLLECTION, id, {...data, onSave}, options) as Promise<IReport>
    }

    download(id: Key) {
        return RestService.resourceDownload(ReportsService_DOWNLOAD + id)
    }

    collectionUpdateState(ids: number[], state: ReportState): Promise<{ success: boolean; count: number }> {
        return RestService.resourceUpdate(UPDATE_STATES, state, {ids}) as Promise<{ success: boolean, count: number }>
    }

    choiceList(presenterName: string, options?: IRestServiceOptions): Promise<IRestServiceChoiceListResponse> {
        return new Promise(() => {
        })
    }
}

export default ReportsService